// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"76":"91eacb34471a44e07579","816":"01ff30570390dc52d5fd"}[chunkId] + ".chunk.js";
};